import React from "react";
import Image from "next/image";
import moment from "moment";
import Link from "next/link";
import useBookingsDataDetail from "@/utils/queries/hooks/useBookingsDataDetail";
import { MDBRow } from "mdb-react-ui-kit";
import { BounceLoader } from "react-spinners";
import styles from "../../../styles/booking/personalInfoSection.module.scss";

const PersonalInfoSection: React.FC<{ bookingId: string }> = ({
    bookingId,
}) => {
    const { data: bookingsDetail, isFetched } =
        useBookingsDataDetail(bookingId);
    return (
        <>
            {!isFetched && (
                <MDBRow className="w-100 justify-content-center my-5">
                    <BounceLoader color="#ed6f6f" size={150} />
                </MDBRow>
            )}
            {isFetched && (
                <>
                    <p className={`${styles.title} pb-3 pb-lg-0`}>
                        {bookingsDetail?.title}
                    </p>

                    <div className={styles.container}>
                        <div className={styles.line}>
                            <div className={styles.sxColumn}>
                                <Image
                                    src="/images/bookingCodeIcon.svg"
                                    height={20}
                                    width={20}
                                    alt="booking code icon"
                                />
                                <span>Booking code:</span>
                            </div>
                            <span className={styles.valueText}>
                                {bookingsDetail?.bookingCode}
                            </span>
                        </div>

                        <div className={styles.line}>
                            <div className={styles.sxColumn}>
                                <Image
                                    src="/images/dateIcon.svg"
                                    height={20}
                                    width={20}
                                    alt="date icon"
                                />
                                <span>Date:</span>
                            </div>
                            <span className={styles.valueText}>
                                {moment(bookingsDetail?.startDate).format(
                                    "Do MMMM"
                                )}{" "}
                                -{" "}
                                {moment(bookingsDetail?.endDate).format(
                                    "Do MMMM"
                                )}
                            </span>
                        </div>

                        <div className={styles.line}>
                            <div className={styles.sxColumn}>
                                <Image
                                    src="/images/billIcon.svg"
                                    height={20}
                                    width={20}
                                    alt="total icon"
                                />
                                <span>Total</span>
                            </div>
                            <span className={styles.valueText}>
                                ${bookingsDetail?.totalAmount}
                            </span>
                        </div>

                        <div className={styles.line}>
                            <div className={styles.sxColumn}>
                                <Image
                                    src="/images/creditCardIcon.svg"
                                    height={20}
                                    width={20}
                                    alt="payment method icon"
                                />
                                <span>Payment method:</span>
                            </div>
                            <span className={styles.valueText}>
                                {bookingsDetail?.cardType}
                            </span>
                        </div>
                    </div>

                    <p className={`${styles.title} py-3 py-lg-0`}>Travelers</p>

                    <div className={styles.container}>
                        {bookingsDetail?.travelers?.map((people, index) => (
                            // eslint-disable-next-line react/no-array-index-key
                            <div className={styles.line} key={index}>
                                <div className={styles.sxColumn}>
                                    <Image
                                        src="/images/people.svg"
                                        height={20}
                                        width={20}
                                        alt="traveler icon"
                                    />
                                    <span>Traveler {index + 1}:</span>
                                </div>
                                <span className={styles.valueText}>
                                    {bookingsDetail.travelers.at(index)}
                                </span>
                            </div>
                        ))}
                    </div>
                </>
            )}

            <div className={styles.containerNeedHelp}>
                <p className={styles.text}>
                    Need Help?{" "}
                    <span>
                        <Link href="/faq" className={styles.textLink}>
                            Let`s talk about it.
                        </Link>
                    </span>
                </p>
            </div>
        </>
    );
};

export default PersonalInfoSection;
